import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'

interface AccountActionsRowProps {
  ariaPressed?: boolean
  onClick: () => void
  isLast?: boolean
  primaryText: string
  secondaryText: string
}

const AccountActionsRow: React.FC<React.PropsWithChildren<AccountActionsRowProps>> = ({
  ariaPressed,
  children,
  isLast = false,
  onClick,
  primaryText,
  secondaryText,
}) => {
  return (
    <ListItem
      sx={{
        backgroundColor: 'background.paper',
        position: 'relative',
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          right: 0,
          left: isLast ? 0 : 24,
          borderBottom: '1px solid',
          borderColor: 'divider',
        },
      }}
    >
      <ListItemButton aria-pressed={ariaPressed} onClick={onClick}>
        <ListItemText primary={primaryText} secondary={secondaryText} />
        {children}
      </ListItemButton>
    </ListItem>
  )
}

export default AccountActionsRow
